import React from 'react';
import { TasksNavigation } from './tasksnavigation';
import { TasksHeader } from './tasksheader';
import ViewTasks from './viewtasks/viewtasks';
import CreateTask from './createtask/createtask';

export enum TaskStatus{
	Default='DEFAULT',
	GetList='GETLIST',
	GetListError='GETLISTERROR',
	GetTask='GETTASK',
	GetTaskDataError='GETTASKDATAERROR',
	GetTaskMetaError='GETTASKMETAERROR',
	ResetTask='RESETTASK',
	ResetTaskFailed='RESETTASKFAILED',
	DeleteTask='DELETETASK',
	DeleteTaskFailed='DELETETASKFAILED',
}

export enum TaskCreateStatus{
	Default='DEFAULT',
	Create='CREATE',
	Success='SUCCESS',
	Failed='FAILED',
	FailedDelete='FAILEDDELETE'
}

export interface TaskData{
	metaData:TaskDataMeta;
	tableData:TaskDataTableRow[];
}

export interface TaskDataTableRow{
	rank:number;
	name:string;
	complete:string;
	score:number;
}

export interface TaskDataMeta{
	contentType: string;
	contentTitle: string;
	creatorMail:string;
	taskTitle:string;
	scoreType: string;
	pageDir: string;
	taskOptions: TaskOption[];
}

export const getEmptyTasksData=function<TaskData>(){
	return{
		metaData:{ contentType: '', contentTitle: '', creatorMail:'', taskTitle:'', pageDir: '', scoreType: '', taskOptions: []},
		tableData:[]
	}
}

export interface TaskOption{optID:string,optVal:number}

export enum TaskScreens{
	None='NONE',
	View='VIEW',
	Create='CREATE'
}

interface StateType{
	curScreen:TaskScreens
}

interface PropsType{
	usermail:string;
	tasksList:string[];
	oneTasksData:TaskData;
	taskStatus:TaskStatus;
	taskCreateStatus:TaskCreateStatus;
	userContentList:string[];
	getTask:Function;
	taskControlsClick:Function;
	taskCreateClick:Function;
	resetTaskStatus:Function;
}

const NOT_LOGGED_IN_MSG:React.ReactElement=<p className='teachers-statusmessage'>Not logged in</p>;

export default class Tasks extends React.Component<PropsType>{

	public state:StateType;

	constructor(props:PropsType){
		super(props);

		this.resetTaskStatus=this.resetTaskStatus.bind(this);

		this.state={
			curScreen:TaskScreens.None
		}
	}

	changeScreen(newScreen:TaskScreens){
		this.resetTaskStatus();
		this.setState({curScreen:newScreen});
	}

	resetTaskStatus(){
		this.props.resetTaskStatus();
	}

	render() {
		if(this.props.usermail==='')return NOT_LOGGED_IN_MSG;
		let showView=this.state.curScreen===TaskScreens.View;
		let showCreate=this.state.curScreen===TaskScreens.Create;
		return (
			<div id='teachers-tasks'>
				<hr />
				<TasksHeader />
				<TasksNavigation 
					changeScreen={(newScreen:TaskScreens)=>{this.changeScreen(newScreen)}}
				/>
				{showView&&<ViewTasks 
					usermail={this.props.usermail}
					tasksList={this.props.tasksList}
					oneTasksData={this.props.oneTasksData}
					taskStatus={this.props.taskStatus}
					getTask={this.props.getTask}
					taskControlsClick={this.props.taskControlsClick}
				/>}
				{showCreate&&<CreateTask 
					taskCreateStatus={this.props.taskCreateStatus}
					tasksList={this.props.tasksList}
					userContentList={this.props.userContentList}
					createClick={this.props.taskCreateClick}
					usermail={this.props.usermail}
					resetTaskStatus={this.resetTaskStatus}
				/>}
			</div>
		);
	}
}
